/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/experiment-workflow/entity-state-updated
 * @desc Column Definition for experiment workflow where we show the time entity state was updated
 */

import type { ValueGetterParams } from 'ag-grid-community';
import { ICONS } from 'labstep-web/constants/icons';
import { useParamsStateContext } from 'labstep-web/contexts/params-state/hook';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import type { Entity } from 'labstep-web/models/entity.model';
import {
  dateOnlyAtUTC,
  humanReadableDateAtUTC,
} from 'labstep-web/services/date.service';

export const colDefExperimentWorkflowEntityStateUpdatedAt = {
  colId: 'entity_state_updated',
  headerName: 'Status Last Updated',
  headerComponentParams: {
    icon: 'clock',
  },
  editable: false,
  autoHeight: true,
  valueGetter: (params: ValueGetterParams): number | null =>
    params.data?.entity_state_updated_log?.created_at || null,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data?.entity_state_updated_log?.created_at || '',
  cellRenderer: (params: CellRendererParams<Entity>) => {
    const { entityView } = useParamsStateContext();
    if (!entityView) {
      return null;
    }
    if (!params.data?.entity_state_updated_log) {
      return '';
    }
    return (
      <div>
        {humanReadableDateAtUTC(
          params.data.entity_state_updated_log?.created_at,
        )}
      </div>
    );
  },
};
